import { api } from './client'

/**
 * Bill service — clean domain API for pre-bills and billing workflow.
 */
const billService = {
  getPreBills: async ({ status, attorney, q, limit = 50, offset = 0 } = {}) => {
    const params = { limit, offset }
    if (status) params.status = status
    if (attorney) params.attorney = attorney
    if (q) params.q = q
    const resp = await api.get('/bills', params)
    return { bills: resp.data, total: resp.meta.total }
  },

  getBill: async (billId) => {
    const resp = await api.get(`/bills/${billId}`)
    return resp.data
  },

  getBillLineItems: async (billId) => {
    const resp = await api.get(`/bills/${billId}/line-items`)
    return resp.data
  },

  updateLineItem: async (billId, entryId, changes) => {
    const resp = await api.put(`/bills/${billId}/line-items/${entryId}`, changes)
    return resp.data
  },

  approveBill: async (billId, { action, comment, version, userName, userId } = {}) => {
    const resp = await api.post(`/bills/${billId}/approve`, { action, comment, version, userName, userId })
    return resp.data
  },

  postBill: async (billId) => {
    const resp = await api.post(`/bills/${billId}/post`)
    return resp.data
  },

  batchPostBills: async (billIds) => {
    const resp = await api.post('/bills/batch-post', { billIds })
    return resp.data
  },

  getApprovalInfo: async (billId) => {
    const resp = await api.get(`/bills/${billId}/approval-info`)
    return resp.data
  },

  getBillPreview: async (billId, { showMarkup = false } = {}) => {
    const params = {}
    if (showMarkup) params.showMarkup = 'true'
    const resp = await api.get(`/bills/${billId}/preview`, params)
    return resp.data
  },

  // --- New: Pre-bill approval workflow ---

  /** Get user settings and pre-bill queue for a specific user (admin "approve for others") */
  getUserSettings: async (userId, { outsideApproval = false, invoiceId } = {}) => {
    const params = { userId }
    if (outsideApproval) params.outsideApproval = 'true'
    if (invoiceId) params.invoiceId = invoiceId
    const resp = await api.get('/bills/approval/user-settings', params)
    return resp.data
  },

  /** Check if pre-bill approval feature is enabled + posting permissions */
  getApprovalEnabled: async () => {
    const resp = await api.get('/bills/approval/enabled')
    return resp.data
  },

  /** Get pre-bill approval configuration (admin only) */
  getApprovalSettings: async () => {
    const resp = await api.get('/bills/approval/settings')
    return resp.data
  },

  /** Get count of upcoming pre-bills for a user */
  getUpcomingCount: async (userId) => {
    const resp = await api.get('/bills/approval/upcoming', { userId })
    return resp.data
  },

  /** Get snapshot version history with approver colors */
  getSnapshotHistory: async (billId) => {
    const resp = await api.get(`/bills/${billId}/snapshot-history`)
    return resp.data
  },

  /** Get matter ID and name for an invoice */
  getMatterInfo: async (billId) => {
    const resp = await api.get(`/bills/${billId}/matter-info`)
    return resp.data
  },

  /** Get rendered HTML for a specific snapshot version */
  getSnapshot: async (billId, version) => {
    const resp = await api.get(`/bills/${billId}/snapshot/${version}`)
    return resp.data
  },
}

export default billService
